module.exports = __webpack_public_path__ + "images/thumbs-upe894042fb8d352a731e5dfae9431225c.svg";